import { render, staticRenderFns } from "./FarmMenu.vue?vue&type=template&id=6fbff686&scoped=true&"
import script from "./FarmMenu.vue?vue&type=script&lang=js&"
export * from "./FarmMenu.vue?vue&type=script&lang=js&"
import style0 from "./FarmMenu.vue?vue&type=style&index=0&id=6fbff686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbff686",
  null
  
)

export default component.exports